/**
 * Surfaces an upload rejection to the user, or nothing at all when they merely cancelled the picker.
 * @module
 */
import { NOTIFICATION_TIMEOUTS } from "common/constants";
import type { UserNotificationType } from "common/types/userNotification";
import { NO_FILE_SELECTED, UPLOAD_ABORTED } from "common/utils/uploadFile";

type SetUserNotification = (notification: UserNotificationType | null) => void;

export function notifyUploadError(error: unknown, setUserNotification: SetUserNotification): void {
  const message = String(error);
  if (message === UPLOAD_ABORTED || message === NO_FILE_SELECTED) {
    return;
  }

  setUserNotification({
    messageType: "error",
    message: `Error - ${message}`,
    timeout: NOTIFICATION_TIMEOUTS.LONG,
  });
}
